import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../css/section-prices.css';
import CompPrices from './compPrices';

function SectionPrices() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleOpenModal = (plan, price) => {
    setSelectedPlan({ plan, price });
  };

  const handleCloseModal = () => {
    setSelectedPlan(null);
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "5491127093931"; 
    const message = `Hola, estoy interesado en el *${selectedPlan.plan}* (${selectedPlan.price}). ¿Podrían darme más información?`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className='container'>
      <div className='row'>
        <CompPrices titleBanner="Plan Básico (Landing Page)" price="USD 99" ofer1="Landing o página web" ofer2="Diseño personalizado" ofer3="Hosting gratuito" ofer4="Dominio personalizado gratuito" ofer5="Mantenimiento mensual" ofer6="SEO y posicionamiento" ofer7="Conexión con redes sociales" onClick={() => handleOpenModal("Plan Básico", "115")} /> 
        <CompPrices titleBanner="Plan Estandar (E-commerce)" price="USD 165" ofer1="Desarrollo de e-commerce" ofer2="Diseño de tienda online" ofer3="Hosting gratuito" ofer4="Dominio personalizado gratuito" ofer5="Mantenimiento mensual" ofer6="SEO y posicionamiento" ofer7="Integración de mercado pago" onClick={() => handleOpenModal("Plan Estandar", "230")} /> 
        <CompPrices titleBanner="Plan Pro (Software)" price="Consultar" ofer1="Desarrollo de software" ofer2="Herramientas personalizadas" ofer3="Desarrollo de apps" ofer4="Desarrollo de sistemas" ofer5="integración de sistemas" ofer6="Resolución de problemáticas" ofer7="Innovación con tecnología" onClick={() => handleOpenModal("Plan Pro", "Consultar")} />
      </div>

      <AnimatePresence>
        {selectedPlan && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className="modal-content"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              <div className='banner-card-price'>
                <h3 className='text-banner-card-price'>{selectedPlan.plan}</h3>
              </div>
              <div className='card-modal'>
                <h3 className='price-modal'>Precio: ${selectedPlan.price}/MES </h3>
                <p>Este plan incluye beneficios para mejorar tu negocio con tecnología.</p>
                <motion.button
                  className="btn-wpp"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleWhatsAppClick}
                >
                  Consultar en WhatsApp
                </motion.button>
                <motion.button
                  className="btn-calendar"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => window.open("https://calendly.com/agenciajgtc", "_blank")}
                >
                  Agendar Llamada
                </motion.button>
                <motion.button
                  className="btn-close"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleCloseModal}
                >
                  Cerrar
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default SectionPrices;
